import { FC } from 'react';

interface EditIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const EditIcon: FC<EditIconProps> = ({ color = 'currentColor', size = '16', className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7803 2.21967C13.4874 1.92678 13.0126 1.92678 12.7197 2.21967L11.9482 2.99111L13.0089 4.05177L13.7803 3.28033C14.0732 2.98744 14.0732 2.51256 13.7803 2.21967ZM12.3018 4.75888L11.2411 3.69822L5.64057 9.29877C5.34686 9.59248 5.13096 9.95474 5.01238 10.3528L4.74306 11.2569L5.64718 10.9876C6.04526 10.869 6.40753 10.6531 6.70124 10.3594L12.3018 4.75888ZM12.0126 1.51256C12.696 0.829146 13.804 0.829146 14.4874 1.51256C15.1709 2.19598 15.1709 3.30402 14.4874 3.98744L7.40834 11.0665C6.99715 11.4777 6.48998 11.78 5.93267 11.946L4.14274 12.4792C3.96679 12.5316 3.77627 12.4834 3.64645 12.3535C3.51663 12.2237 3.46839 12.0332 3.52081 11.8573L4.05399 10.0673C4.22001 9.51003 4.52227 9.00286 4.93346 8.59167L12.0126 1.51256ZM3.5 4.49999C2.94772 4.49999 2.5 4.94771 2.5 5.49999V12.5C2.5 13.0523 2.94772 13.5 3.5 13.5H10.5C11.0523 13.5 11.5 13.0523 11.5 12.5V9.33333C11.5 9.05719 11.7239 8.83333 12 8.83333C12.2761 8.83333 12.5 9.05719 12.5 9.33333V12.5C12.5 13.6046 11.6046 14.5 10.5 14.5H3.5C2.39543 14.5 1.5 13.6046 1.5 12.5V5.49999C1.5 4.39542 2.39543 3.49999 3.5 3.49999H6.66667C6.94281 3.49999 7.16667 3.72385 7.16667 3.99999C7.16667 4.27614 6.94281 4.49999 6.66667 4.49999H3.5Z"
        fill={color}
      />
    </svg>
  );
};
